var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlinePlayCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.54 19.6a.754.754 0 0 1 0-1.06c3.61-3.61 3.61-9.48 0-13.08a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0 4.19 4.19 4.19 11.01 0 15.2-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM4.4 19.6C.21 15.41.21 8.59 4.4 4.4c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06-3.61 3.61-3.61 9.48 0 13.08.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM8.449 22.11a.754.754 0 0 1-.46-.96c.14-.39.56-.6.96-.46.96.33 1.98.51 3.06.51 1.07 0 2.1-.18 3.05-.51.39-.13.82.07.96.46s-.07.82-.46.96c-1.12.39-2.31.6-3.56.6-1.25-.01-2.44-.21-3.55-.6zM15.05 3.3a9.4 9.4 0 0 0-6.109 0 .763.763 0 0 1-.96-.46c-.14-.39.07-.82.46-.96 1.11-.39 2.31-.59 3.55-.59 1.24 0 2.44.2 3.55.59.39.14.6.57.46.96-.1.31-.39.5-.7.5-.08 0-.17-.01-.25-.04z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33 16.44c-.86-.5-1.34-1.48-1.34-2.76v-3.35c0-1.28.47-2.26 1.34-2.76.86-.5 1.95-.42 3.06.22l2.9 1.67c1.11.64 1.72 1.54 1.72 2.54s-.61 1.9-1.72 2.54l-2.9 1.67c-.63.37-1.26.55-1.83.55-.44 0-.86-.11-1.23-.32zm.75-7.58c-.37.22-.59.75-.59 1.46v3.35c0 .71.21 1.25.59 1.46.37.21.94.13 1.56-.22l2.9-1.67c.62-.36.97-.81.97-1.24 0-.43-.35-.88-.97-1.24l-2.9-1.67c-.4-.23-.77-.35-1.08-.35-.18 0-.35.04-.48.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePlayCricle);
export default __webpack_public_path__ + "static/media/vuesax-outline-play-cricle.12cbe554c55b89cf550525aa8eec88fb.svg";
export { ForwardRef as ReactComponent };